import React from 'react';
import { Link } from '../../routing';
import './ServicePricing.scss';

export interface ServicePriceOption {
  name: string;
  detail: string;
  includes: string[];
  price?: string;
  badge?: string;
  ctaLabel?: string;
  ctaTarget?: string;
}

interface ServicePricingProps {
  options: ServicePriceOption[];
  notes?: string[];
  eyebrow?: string;
  title?: string;
  intro?: string;
}

const ServicePricing: React.FC<ServicePricingProps> = ({ options, notes, eyebrow = 'PACKAGES', title = 'Choose your coverage', intro = 'Every project can be tailored to your brief.' }) => <section className="service-pricing"><div className="service-pricing__heading"><p>{eyebrow}</p><h2>{title}</h2><span>{intro}</span>{notes && <div className="service-pricing__notes">{notes.map(note => <small key={note}>{note}</small>)}</div>}</div><div className="service-pricing__grid">{options.map(option => <article className={option.badge ? 'is-recommended' : ''} key={option.name}>{option.badge && <span className="service-pricing__badge">{option.badge}</span>}{option.price && <strong className="service-pricing__price">{option.price}</strong>}<h3>{option.name}</h3><p>{option.detail}</p><ul>{option.includes.map(item => <li key={item}>{item}</li>)}</ul><Link className="btn btn-accent service-pricing__cta" to={option.ctaTarget || '/contact'}>{option.ctaLabel || 'Discuss your project'} <span>→</span></Link></article>)}</div></section>;
export default ServicePricing;
